import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';
import { BarChart3 } from 'lucide-react';

export const GoogleAnalyticsSettings = () => {
  const { trackingId, setTrackingId, isInitialized } = useGoogleAnalytics({ debug: true });
  const [inputTrackingId, setInputTrackingId] = useState(trackingId || '');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputTrackingId.trim()) {
      setTrackingId(inputTrackingId.trim());
    }
  };

  return (
    <Card className="border-border/50 shadow-xl bg-gradient-to-br from-background via-background to-muted/10 hover:shadow-2xl transition-all duration-300">
      <CardHeader className="border-b border-gradient-to-r from-transparent via-[hsl(var(--tab-analytics))]/20 to-transparent">
        <CardTitle className="flex items-center gap-3">
          <div className="p-2.5 rounded-xl bg-gradient-to-br from-[hsl(var(--tab-analytics))] to-[hsl(var(--tab-analytics))]/80 shadow-lg shadow-[hsl(var(--tab-analytics))]/30">
            <BarChart3 className="w-5 h-5 text-white" />
          </div>
          <span className="bg-gradient-to-r from-foreground to-muted-foreground bg-clip-text text-transparent">إعداد Google Analytics</span>
        </CardTitle>
        <CardDescription className="text-base">
          إضافة رمز تتبع Google Analytics لمراقبة زيارات الموقع
        </CardDescription>
      </CardHeader>
      <CardContent className="p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="p-4 bg-gradient-to-br from-muted/20 to-muted/10 rounded-xl border border-border/50">
            <label htmlFor="ga-tracking-id" className="block text-base font-medium mb-3">
              رمز التتبع (Tracking ID)
            </label>
            <Input
              id="ga-tracking-id"
              value={inputTrackingId}
              onChange={(e) => setInputTrackingId(e.target.value)}
              placeholder="أدخل رمز التتبع (مثال: G-XXXXXXXXXX أو UA-XXXXXXXX-X)"
              required
              className="border-border/50 focus:ring-2 focus:ring-[hsl(var(--tab-analytics))]/30 transition-all"
            />
            <p className="text-sm text-muted-foreground mt-3">
              يمكنك الحصول على رمز التتبع من{' '}
              <a 
                href="https://analytics.google.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:underline font-medium"
              >
                Google Analytics
              </a>
            </p>
          </div>
          <Button type="submit" className="w-full bg-gradient-to-r from-[hsl(var(--tab-analytics))] to-[hsl(var(--tab-analytics))]/80 hover:shadow-lg hover:scale-105 transition-all">
            {isInitialized ? 'تحديث رمز التتبع' : 'تفعيل التحليلات'}
          </Button>
          
          {isInitialized && (
            <div className="p-4 bg-gradient-to-br from-success/10 to-success/5 border border-success/20 rounded-xl">
              <p className="text-sm text-success font-medium flex items-center gap-2">
                <span className="text-lg">✓</span>
                تم تفعيل Google Analytics بنجاح
              </p>
            </div>
          )}
        </form>
      </CardContent>
    </Card>
  );
};